import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, message, Tag } from 'antd';
import moment from 'moment';
import './styles.css';

import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';
import { REQUERIMIENTO } from '../../../common/types/tipoComprobanteType';

import DetalleProductoServicioModal from './FormModal/DetalleProductoServicioModal';
import DetalleReferenciaModal from './FormModal/DetalleReferenciaModal';

import global from '../../../common/utility/global';

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

const tipo_requeremiento = [{ codigo: 1, nombre: "Bienes" }, { codigo: 2, nombre: "Servicios" }]



class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    findDaysAndDates = (property, value) => {
        if (property === 'diasVencimiento') {
            const fecha = moment(this.props.form.getFieldValue('fechaStr'), 'DD/MM/YYYY');
            const diasVencimiento = parseInt(value);
            this.props.form.setFieldsValue({ fechaVencimientoStr: fecha.add('days', diasVencimiento) });
        }

        if (property === 'fechaVencimientoStr') {
            const fecha = moment(this.props.form.getFieldValue('fechaStr'), 'DD/MM/YYYY');
            const fechaVencimiento = moment(value, 'DD/MM/YYYY');
            this.props.form.setFieldsValue({ diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString() });
        }

        if (property === 'fechaStr') {
            const fechaVencimiento = moment(this.props.form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const fecha = moment(value, 'DD/MM/YYYY');
            const mf = fecha.format('YYYY/MM/DD');
            //console.log(fecha.format('YYYY/MM/DD'));
            // const minFechaStr = fecha.format('DD/MM/YYYY')
            this.props.form.setFieldsValue({ diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString(), minFechaStr: mf });
            //this.props.form.setFieldsValue({ minFechaStr: mf });
        }
    };

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }

    handleRemoverProducto = (identifier) => {
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        //var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== "psd" + identifier });
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== identifier });
        //var _sumaSubTotal = 0;
        //arrDetalleFilter.forEach(item => {
        //    _sumaSubTotal = _sumaSubTotal + item.subTotal;
        //});

        //var sumaImporteDescuento = this.fetchFieldValueSum("psd" + identifier, "arrImporteDescuento", 0);
        //var sumaIsc = this.fetchFieldValueSum("psd" + identifier, "arrIsc", 0);
        //var sumaTotal = this.fetchFieldValueSum("psd" + identifier, "arrTotal", 0);
        //var sumaSubTotal = _sumaSubTotal;
        //var sumaIgv = sumaTotal - sumaSubTotal;
        //var sumaTotalDetalle = sumaSubTotal - sumaImporteDescuento;

        this.props.form.setFieldsValue({
            //    sumaImporteDescuento: sumaImporteDescuento,
            //    sumaIsc: sumaIsc,
            //    sumaTotal: sumaTotal,
            //    sumaSubTotal: sumaSubTotal,
            //    sumaIgv: sumaIgv,
            //    sumaTotalDetalle: sumaTotalDetalle,
            arrDetalle: arrDetalleFilter
        });

        this.props.onRemoverProducto(identifier);
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {

                const form = {
                    id: values.id,
                    idProyecto: values.idProyecto.key == null ? 0 : values.idProyecto.key,

                    idTipoComprobante: REQUERIMIENTO.ID,
                    idRequerimientoEstado: 1,
                    fecha: null,
                    //fechaStr: values.fechaStr._i,
                    fechaStr: values.fechaStr.format('DD/MM/YYYY'),
                    serie: values.serie,
                    documento: values.documento,
                    idEntidad: values.idEntidad.key,
                    diasVencimiento: parseInt(values.diasVencimiento),
                    fechaVencimiento: null,
                    //fechaVencimientoStr: values.fechaVencimientoStr._i,
                    fechaVencimientoStr: values.fechaVencimientoStr.format('DD/MM/YYYY'),
                    idEstablecimiento: values.idEstablecimientoEntidad.key,
                    idActividad: values.codigoTipo.key,
                    tipoCambio: parseFloat(values.tipoCambio),

                    flag: false,
                    observacion: values.observacion,
                    observacionRechazado: null,
                    requerimientoDetalles: [],
                    requerimientoReferencias: [],
                    fechaRechazo: null,
                    fechaImporto: null
                    //nombre: values.nombre,
                    //idEstablecimiento: values.idEstablecimiento.key
                }

                //Referencias-->
                if (values.idTipoComprobante !== undefined) {
                    var count_referencias = values.idTipoComprobante.length;// - 1;
                    for (var i = 0; i < count_referencias; i++) {
                        var tc = values.idTipoComprobante[i];
                        if (tc !== undefined) {
                            const itemRef = {
                                id: 0,
                                idRequerimiento: 0,
                                idReferenciaOrigen: values.arrIdReferenciaOrigen[i],
                                idReferencia: values.arrIdReferencia[i],
                                idTipoComprobante: tc.key,
                                serie: values.series[i],
                                documento: values.documentos[i],
                                flagInterno: values.arrFlagInterno[i],
                            }
                            form.requerimientoReferencias.push(itemRef);
                        }
                    }
                }

                if (values.arrDetalle.length <= 0) {
                    message.error('Debe de ingresar como mínimo 1 producto.');
                    return;
                }

                if (parseFloat(values.tipoCambio) <= 0) {
                    message.error('Debe de ingresar tipo de cambio.');
                    return;
                }

                var containsZero = false;
                //Detalles----->
                var count_detalles = values.arrDetalle.length;
                for (var i = 0; i < count_detalles; i++) {
                    var det = values.arrDetalle[i];
                    const itemDet = {
                        id: 0,
                        idRequerimiento: 0,
                        idProducto: parseInt(det.identifier),
                        nombre: det.nombre,
                        idImpuesto: det.idImpuesto,
                        cantidad: det.cantidad
                    }

                    if (det.cantidad == 0) {
                        containsZero = true;
                    }

                    form.requerimientoDetalles.push(itemDet);
                }

                if (containsZero == true) {
                    message.warning('Debe de ingresar una cantidad mayor a cero en todos los productos.');
                    return;
                }

                this.props.onSave(form, this.props.form);
            }
        });
    };

    fetchNewValue = (value, numberDecimals) => {
        if (numberDecimals === 2)
            return value === '' || isNaN(parseFloat(value).toFixed(2)) ? 0 : parseFloat(value);
        if (numberDecimals === 3)
            return value === '' || isNaN(parseFloat(value).toFixed(3)) ? 0 : parseFloat(value);
        if (numberDecimals === 5)
            return value === '' || isNaN(parseFloat(value).toFixed(5)) ? 0 : parseFloat(value);
        if (numberDecimals === 0)
            return value === '' || isNaN(parseFloat(value).toFixed(0)) ? 0 : parseFloat(value);
        return 0;
    };

    handleCalculateDetail = (identifier, property, value, numberDecimals, row) => {
        var newValue = this.fetchNewValue(value, numberDecimals);
        var cantidad = property === "arrCantidad" ? newValue : this.fetchFieldValue(identifier, "arrCantidad");

        /*********** Arr Detalle ********/
        var detalle = {
            identifier,
            cantidad,
            nombre: row.nombre,
            idImpuesto: row.idImpuesto
        };

        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== identifier });
        arrDetalleFilter.push(detalle);

        this.props.form.setFieldsValue({
            arrDetalle: arrDetalleFilter
        });
    };

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.props.onChangeNameProduct(row);
    }

    handleSearchAutocompleteEntidad = async (value) => {
        const result = this.props.formValues.entidades.filter(item => {
            return global.formatSearch(`${item.nombre} - ${item.tipoDocumento}`).match(global.formatSearch(value));
        }).slice(0, 75);
        this.props.form.setFieldsValue({ entidades: result });
    }

    handleChangeAutocompleteEntidad = async (a, element) => {
        this.props.form.setFieldsValue({
            documentoEntidad: element.props.data.numeroDocumento
        }, () => {
            this.props.onChange("idEntidad", element.props.data.id, this.props.form)
        });
    }

    render() {
        //debugger
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        var arrayTemp = [];
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        for (var i = 0; i < this.props.formValues.listaComprobanteDetalle.length; i++) {
            var item = this.props.formValues.listaComprobanteDetalle[i];
            var existItem = arrDetalle.filter(m => { return m.identifier === item.idProducto })
            var d = {
                identifier: item.idProducto,
                cantidad: existItem.length === 0 ? item.cantidad : existItem[0].cantidad,
                idImpuesto: item.idImpuesto,
                nombre: item.nombre
            };
            arrayTemp.push(d);
        }

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('arrDetalle', { initialValue: arrayTemp });
        getFieldDecorator('entidades', { initialValue: [] });
        return (
            <Modal
                title={(<div> {this.props.formValues.id === 0 ? `Registrar Requerimiento` : `Modificar Requerimiento`}</div>)}
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="900px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('minFechaStr', { initialValue: this.props.formValues.minFechaStr })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('idRequerimientoReferencia', { initialValue: this.props.formValues.idRequerimientoReferencia })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => this.findDaysAndDates('fechaStr', value)}
                                            />
                                        )}
                                    </Form.Item>

                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie,
                                            rules: [{
                                                required: true,
                                                message: 'Requerido',
                                                whitespace: true
                                            }]
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento,
                                            rules: [{
                                                //required: true,
                                                //message: 'Requerido',
                                                whitespace: true
                                            }]
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Dias / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('diasVencimiento', {
                                            initialValue: this.props.formValues.diasVencimiento,
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_NUMBER),
                                                message: "Formato incorrecto"
                                            }]
                                        })(
                                            <Input
                                                style={{ textAlign: 'right' }}
                                                placeholder="Ingresar días de vencimiento"
                                                autoComplete="off"
                                                className="first-input"
                                                onBlur={(e) => this.findDaysAndDates('diasVencimiento', e.target.value)}

                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaVencimientoStr', {
                                            initialValue: moment(this.props.formValues.fechaVencimientoStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                className="second-input"
                                                onChange={(moment, value) => this.findDaysAndDates('fechaVencimientoStr', value)}
                                                disabledDate={d => !d || d.isBefore(this.props.form.getFieldValue('minFechaStr'))}

                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Nro Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('documentoEntidad', {
                                            initialValue: this.props.formValues.documentoEntidad,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Search
                                                placeholder="Numero de documento / Nombre”"
                                                className="first-input"
                                                autoComplete="off"
                                                loading={this.props.formValues.entidadLoading}
                                                onSearch={value => this.props.onBuscarEntidad(value, this.props.form)}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-9 form-group">
                            <Form.Item label="Entidad">
                                <InputGroup compact>

                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('idEntidad', {
                                            initialValue: this.props.formValues.idEntidad ?
                                                { key: this.props.formValues.idEntidad } : undefined,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Select showSearch labelInValue
                                                placeholder={"Seleccione Entidad"}
                                                optionFilterProp="children"
                                                className="second-input"
                                                // onSearch={value => this.props.onBuscarEntidad(value)}
                                                onSearch={this.handleSearchAutocompleteEntidad}
                                                onChange={this.handleChangeAutocompleteEntidad}
                                            >
                                                {
                                                    this.props.formValues.entidades.map(item => (
                                                        <Option
                                                            key={item.id}
                                                            value={item.id}
                                                            data={item}
                                                        >
                                                            <Tag>{item.tipoDocumentoNombre}</Tag>{`${item.nombre}-${item.numeroDocumento}`}
                                                        </Option>
                                                    ))
                                                    // this.props.formValues.entidades.map(item => (
                                                    //     <Option key={item.id} value={item.id}>{item.nombre + ' - ' + item.tipoDocumentoNombre + ' - ' + item.numeroDocumento}</Option>
                                                    // ))
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>


                    </div>

                    <div className="row">
                        <div className="col-md-9 form-group">
                            <Form.Item label="Direccion">
                                {getFieldDecorator('idEstablecimientoEntidad', {
                                    initialValue: this.props.formValues.idEstablecimientoEntidad ?
                                        { key: this.props.formValues.idEstablecimientoEntidad } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Dirección"}
                                        optionFilterProp="children"
                                        readOnly
                                    >
                                        {this.props.formValues.direcciones.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre + ' - ' + item.direccion}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator("idProyecto", {
                                    initialValue: this.props.formValues.idProyecto
                                        ? { key: this.props.formValues.idProyecto }
                                        : 0,
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.proyectos.map(item => (
                                            item.estado ?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-md-4 form-group">
                            <Form.Item label="Tipo">
                                {getFieldDecorator('codigoTipo', {
                                    initialValue: this.props.formValues.codigoTipo ?
                                        { key: this.props.formValues.codigoTipo } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('codigoTipo', option.key)}
                                    >
                                        {tipo_requeremiento.map(item => (
                                            <Option key={item.codigo} value={item.codigo}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-8 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="import"
                                            type="primary"
                                            onClick={this.props.onImportarRequerimiento}
                                            hidden={true}
                                        >
                                            Importar Requerimiento
                                        </Button>
                                        <Button
                                            icon="plus"
                                            type="primary"
                                            onClick={this.props.onAgregarDetalle}
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <DetalleProductoServicioModal
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        onRemove={this.handleRemoverProducto}
                                        onCalculateDetail={this.handleCalculateDetail}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                        onChangeNameProduct={this.handleChangeNameProduct}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <DetalleReferenciaModal
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        tiposComprobante={this.props.formValues.tiposComprobante}
                                        onRemove={this.props.onRemoverReferencia}
                                        onGetFieldDecorator={getFieldDecorator}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>

                </Form>
            </Modal>
        )
    }
}
export default Form.create()(FormModal)